interface FirebaseConfig {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

interface TipaltiConfig {
  masterKey:string,
  baseURL:string
}

interface Config {
  mode: string
  baseUrl: string
  funnelShare: string
  leadConnectorFrontendBaseUrl: string
  newBaseUrl: string
  ghlRevexBackendWhatsAppBaseUrl: string
  whatsappMetaAppId: number
  whatsappMetaAppVersion: string
  formEmbedUrl: string
  pythonBaseUrl: string
  dialogflowEngagementsBaseUrl: string
  paymentServiceBaseUrl: string
  saasServiceBaseUrl: string
  isvServiceBaseUrl: string
  humanRollOverServiceBaseUrl: string
  funnelServiceBaseUrl: string
  firebase: FirebaseConfig
  cnameRedirectURL: string
  cnameWhitelabelURL?: string
  serverIPAddress: string
  whitelabelIPAddress: string
  fcmPublicKey: string
  fcmSenderId: string
  defaultReviewSMS?: string
  googleMapsAPIKey?: string
  stripeKey?: string
  appId?: string
  googleAnalyticId?: string
  membershipAppUrl?: string
  membershipUrl?: string
  newMembershipUrl?: string
  cacheInvalidateUrl?: string
  attributionUrl?: string
  emailHomeAppUrl: string
  proposalBuilderAppUrl: string
  emailPreviewAppUrl: string
  mediaCenterAppUrl: string
  templateLibraryAppUrl: string
  genericElizaId?: string
  builderPreviewUrl?: string
  companyIdForManagingTemplates: string
  locationIdForTemplateLibrary: string
  snapshotServiceUrl?: string
  smtpServiceUrl: string
  shortenUrlServiceUrl: string
  emailReportingUrl: string
  agentReportingUrl: string
  bulkReqURL: string
  frontEndCNameRedirectURL: string
  workflowAppURL: string
  calendarAppURL: string
  crmOpportunitiesAppURL: string
  crmCustomValuesAppURL: string
  crmTagsAppUrl:string
  calendarRecurringEventsEnabled: string[]
  crmLocationAppURL: string
  newCalendarSettingsEnabled: string[],
  workflowServiceURL: string
  newOnboardingFrontend: string
  hipaaComplianceServiceId: string
  gdprSignDocument: string
  termsOfServiceThrottle: number
  publicApiUrl: string
  restApiUrl: string
  productsApiURL: string
  requestLoggerApiURL: string
  paymentsApiURL: string
  funnelsApiURL: string,
  wordpress:{
    apiUrl: string,
  }
  prospect: {
    frontendUrl: string
  },
  reputation: {
    apiUrl: string,
  },
  cloudFunctionsUrl: string
  phoneCallReportingService: string
  paymentsAppUrl: string
  opportunityReportingService: string
  reserveServiceBaseUrl:string
  deepLinkUrl:string
  depreciatedFeatureDate: string
  googleAuthId: string
  tipalti: TipaltiConfig,
  funnelBuilderAppURL: string
  formBuilderAppURL: string
  socialMediaPlannerAppUrl: string
  affiliateManagerAppUrl: string
  funnelBetaPreviewUrl: string
  formBetaPreviewUrl: string
  surveyBetaPreviewUrl: string
  calendarBetaPreviewUrl: string
  formsApiUrl: string
  surveysApiUrl: string,
  tosVersion: string,
  privacyPolicyVersion: string
  affiliatePolicyVersion: string
  supportPortalUrl: string
  blogsAppUrl: string
  isvAppUrl: string,
  widgetUrl: string,
  conversationsAppUrl: string,
  settingsAppUrl: string,
  triggerLinksAppUrl: string,
  statsApiURL: string,
  mobileAppCustomiserAppUrl: string,
  newFunnelBuilderUrl: string
  isAddGuestsEnabled: Array<string>
  newEmailHomeBetaUrl: string
  newEmailPreviewBetaUrl: string
  conversationsServiceUrl: string
  localizationApiURL?: string
}

const apiUrls = {
  nik: 'https://nik-dot-highlevel-staging.appspot.com',
  abhishek: 'https://abhishek-dot-highlevel-staging.uc.r.appspot.com',
  upamanyu: 'https://upamanyu-dot-highlevel-staging.uc.r.appspot.com',
}

const pythonApiUrls = {
  staging: 'https://python-backend-dot-highlevel-staging.appspot.com',
}

const override = process.env.VUE_APP_DB_OVERRIDE === 'true'
const config: { [key: string]: Config } = {
  development: {
    mode: 'dev',
    funnelShare:'http://localhost:8080/funnels/share',
    leadConnectorFrontendBaseUrl: 'http://localhost:8080',
    baseUrl: `https://highlevel-staging.appspot.com`,
    newBaseUrl: 'https://staging.services.leadconnectorhq.com/appengine',
    ghlRevexBackendWhatsAppBaseUrl: 'http://localhost:9611/phone-system/whatsapp',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v18.0',
    formEmbedUrl: 'https://staging.link.gohighlevel.com/js',
    widgetUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    builderPreviewUrl: 'http://localhost:3344',
    pythonBaseUrl: override
      ? 'https://python-backend-dot-highlevel-backend.appspot.com'
      : 'https://python-backend-dot-highlevel-staging.appspot.com',
    dialogflowEngagementsBaseUrl: override
      ? 'https://services.leadconnectorhq.com/dialogflow-engagement'
      : 'http://localhost:5050',
    paymentServiceBaseUrl: 'https://staging.services.leadconnectorhq.com/payment_service',
    saasServiceBaseUrl: override
      ? 'https://services.leadconnectorhq.com/saas_service' // production saas URL
      : 'https://staging.services.leadconnectorhq.com/saas_service',
      // :'http://localhost:5252/saas_service',
      isvServiceBaseUrl: override
      ? 'https://services.leadconnectorhq.com/isv_service' // production saas URL
      : 'https://staging.services.leadconnectorhq.com/isv_service',
      // :'http://localhost:5253/isv_service',
    humanRollOverServiceBaseUrl: override
      ? 'https://services.leadconnectorhq.com/eliza'
      : 'http://localhost:5020/eliza',
    funnelServiceBaseUrl: override
      ? 'https://services.leadconnectorhq.com/funnel_backend'
      : 'http://localhost:5030/funnel_backend',
    phoneCallReportingService: override
      ? 'https://services.leadconnectorhq.com/phone_call_reporting'
      : 'http://localhost:5010/phone_call_reporting',
    opportunityReportingService: override
      ? 'https://services.leadconnectorhq.com/opportunity_reporting'
      : 'http://localhost:6010/opportunity_reporting',
    frontEndCNameRedirectURL: 'staging.msgsndr.com',
    cnameRedirectURL: 'flash-funnel-staging.msgsndr.com',
    serverIPAddress: '35.222.170.66',
    cnameWhitelabelURL: 'link.msgsndr.com',
    whitelabelIPAddress: override ? '34.70.111.192' : '34.66.216.217',
    companyIdForManagingTemplates: 'eejDKnO8OMdu5q4F7rMB',
    locationIdForTemplateLibrary: 'f8xXtCLtJndXyDchiomd',
    fcmSenderId: override ? '439472444885' : '439472444885',
    fcmPublicKey: override
      ? 'BAVB9sZxhteplpxkSQXvCF57NEXzFZbC3aO6sFxQGH5vujYLN12R6HxD52REe_xMotrXqAIeroKrQlAAgJH3hMc'
      : 'BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4',
    tipalti: override
      ? {
        masterKey: '2CbN+Sct9H/cc41OzqfKX64aZL3SrQqijgzwhpTPv/PDyhJ6badnhD0XTodX6QEX',
        baseURL: 'https://ui2.tipalti.com/payeedashboard/'
      }
      : {
        masterKey: 'O+bfhrct8O02s/Qi4kjdtdPRhqgc5jIj5HEqe//r8hF2133w23FzRfcSGY9NPf9J',
        baseURL: 'https://ui2.sandbox.tipalti.com/payeedashboard/'
      },
    firebase: override
      ? {
          apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
          authDomain: 'highlevel-backend.firebaseapp.com',
          databaseURL: 'https://highlevel-backend.firebaseio.com',
          projectId: 'highlevel-backend',
          storageBucket: 'highlevel-backend.appspot.com',
          messagingSenderId: '439472444885',
          appId: '1:439472444885:android:c48022009a58ffc7',
        }
      : {
          apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
          authDomain: 'highlevel-staging.firebaseapp.com',
          databaseURL: 'https://highlevel-staging.firebaseio.com',
          projectId: 'highlevel-staging',
          storageBucket: 'highlevel-staging.appspot.com',
          messagingSenderId: '85350210461',
          appId: '1:85350210461:web:d3728d34bf8bd6b5',
        },
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    stripeKey: override
      ? 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj'
      : 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    shortenUrlServiceUrl: override
      ? 'https://url-shorten-dot-highlevel-backend.appspot.com/'
      : 'https://url-shorten-dot-highlevel-staging.appspot.com/',
    membershipUrl: override
      ? 'https://services.leadconnectorhq.com/membership'
      : 'https://staging.services.leadconnectorhq.com/membership',
      // : 'http://localhost:7000',
    newMembershipUrl : override ? 'https://services.leadconnectorhq.com/membership' : 'http://localhost:7000',
    membershipAppUrl: 'http://localhost:4000',
    cacheInvalidateUrl: override
      ? 'https://services.leadconnectorhq.com/cache/clear'
      : 'https://staging.services.leadconnectorhq.com/cache/clear',
    attributionUrl: override
      ? 'https://services.leadconnectorhq.com/attribution_service'
      : 'https://staging.services.leadconnectorhq.com/attribution_service',
    emailReportingUrl: override
      ? 'https://services.leadconnectorhq.com'
      : 'http://localhost:5010',
    agentReportingUrl: override
      ? 'https://services.leadconnectorhq.com'
      : 'http://localhost:5020', //'http://localhost:5020'
    bulkReqURL: 'http://localhost:5080',
    emailHomeAppUrl: 'http://localhost:3003',
    proposalBuilderAppUrl: 'http://localhost:3040',
    emailPreviewAppUrl: 'http://localhost:3001',
    mediaCenterAppUrl: 'http://localhost:4040',
    templateLibraryAppUrl: 'http://localhost:8081',
    genericElizaId: 'events-search-enhv',
    workflowAppURL: 'http://localhost:3002',
    calendarAppURL: 'https://staging-client-app-calendars.web.app',
    crmOpportunitiesAppURL: "http://localhost:3031",
    crmCustomValuesAppURL: "http://localhost:3033",
    crmTagsAppUrl: "http://localhost:3033",
    calendarRecurringEventsEnabled: [
      '5DP4iH6HLkQsiKESj6rh',
      'z15tg6TRo3BPFPhquVuz',
    ],
    crmLocationAppURL: 'https://staging-crm-apps-rollup.leadconnectorhq.com',
    newCalendarSettingsEnabled: ["5DP4iH6HLkQsiKESj6rh"],
    workflowServiceURL: 'https://staging.services.leadconnectorhq.com/workflow',
    newOnboardingFrontend: 'https://staging.onboarding.gohighlevel.com',
    hipaaComplianceServiceId: 'tecJjL67Ol5kwLItrBwe',
    gdprSignDocument:
      'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    snapshotServiceUrl: "http://localhost:5000",
    termsOfServiceThrottle: 3,
    publicApiUrl: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
    restApiUrl: 'https://staging.services.leadconnectorhq.com',
    productsApiURL: 'https://staging.services.leadconnectorhq.com',
    paymentsApiURL: 'https://staging.services.leadconnectorhq.com',
    requestLoggerApiURL: 'https://staging.services.leadconnectorhq.com',
    funnelsApiURL: 'https://staging.services.leadconnectorhq.com',
    statsApiURL: 'http://localhost:5105',
    paymentsAppUrl: "http://localhost:3040",
    cloudFunctionsUrl:
      'https://us-central1-highlevel-staging.cloudfunctions.net',
    reserveServiceBaseUrl: 'https://staging.services.leadconnectorhq.com/reserve',
    deepLinkUrl:'https://deep-link-dot-highlevel-staging.uc.r.appspot.com',
    depreciatedFeatureDate: '2021-09-21',
    googleAuthId: "85350210461-eu3b772ek6gqmlpeim86m62ab9i9u5pc.apps.googleusercontent.com",
    funnelBuilderAppURL: "http://localhost:3333",
    formBuilderAppURL: "http://localhost:3032",
    socialMediaPlannerAppUrl: 'http://localhost:3041',
    affiliateManagerAppUrl: 'http://localhost:3020',
    funnelBetaPreviewUrl: 'http://localhost:3344',
    formBetaPreviewUrl: 'http://localhost:3344',
    surveyBetaPreviewUrl: 'http://localhost:3344',
    calendarBetaPreviewUrl: 'http://localhost:3344',
    formsApiUrl: 'http://localhost:5070',
    surveysApiUrl: 'http://localhost:5072',
    tosVersion: '06/01/2022',
    privacyPolicyVersion: '06/01/2022',
    affiliatePolicyVersion: '03/02/2021',
    supportPortalUrl: 'https://ghl-support-portal.web.app/',
    wordpress:{
      apiUrl: 'https://staging.services.leadconnectorhq.com/wordpress',
    },
    prospect: {
      frontendUrl: 'http://localhost:3030'
    },
    reputation: {
      apiUrl: 'https://staging.services.leadconnectorhq.com/reputation'
    },
    blogsAppUrl: 'http://localhost:3030',
    conversationsAppUrl: 'http://localhost:3031',
    isvAppUrl: 'http://localhost:3031',
    settingsAppUrl: 'https://staging-client-app-crm-settings.web.app',
    triggerLinksAppUrl: 'http://localhost:3032',
    localizationApiURL: 'https://staging.services.leadconnectorhq.com/localization',
    newFunnelBuilderUrl: 'https://page-builder-staging--beta-c5b2hybo.web.app',
    newEmailHomeBetaUrl: 'https://hl-email-home--anz-staging-wapmruc1.web.app',
    newEmailPreviewBetaUrl: 'https://hl-email-preview--anz-staging-qj636k3k.web.app',
    isAddGuestsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    conversationsServiceUrl: 'https://staging.services.leadconnectorhq.com/conversations',
    mobileAppCustomiserAppUrl: 'http://localhost:3032/mobile-customiser',
  },
  staging: {
    mode: 'staging',
    leadConnectorFrontendBaseUrl: 'https://staging.gohighlevel.com',
    baseUrl:
    process.env.DEV_ENV && apiUrls[process.env.DEV_ENV]
      ? apiUrls[process.env.DEV_ENV]
      : 'https://highlevel-staging.appspot.com',
    newBaseUrl: 'https://staging.services.leadconnectorhq.com/appengine',
    ghlRevexBackendWhatsAppBaseUrl: 'https://staging.services.leadconnectorhq.com/phone-system/whatsapp',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v18.0',
    formEmbedUrl: 'https://staging.link.gohighlevel.com/js',
    widgetUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    builderPreviewUrl:
      'https://funnel-preview-dot-highlevel-staging.appspot.com',
    pythonBaseUrl:
      process.env.DEV_ENV && pythonApiUrls[process.env.DEV_ENV]
        ? pythonApiUrls[process.env.DEV_ENV]
        : 'https://python-backend-dot-highlevel-staging.appspot.com',
    dialogflowEngagementsBaseUrl:
      'https://staging.services.leadconnectorhq.com/dialogflow-engagement',
    paymentServiceBaseUrl:
      'https://staging.services.leadconnectorhq.com/payment_service',
    saasServiceBaseUrl: 'https://staging.services.leadconnectorhq.com/saas_service', // Staging saas URL
    isvServiceBaseUrl:
    // 'http://localhost:5253/isv_service',
    'https://staging.services.leadconnectorhq.com/isv_service', // Staging isv URL
    humanRollOverServiceBaseUrl:
      'https://staging.services.leadconnectorhq.com/eliza',
    funnelShare:'https://affiliate-dot-highlevel-staging.appspot.com',
    funnelServiceBaseUrl: 'https://staging.services.leadconnectorhq.com/funnel_backend',
    phoneCallReportingService: 'https://staging.services.leadconnectorhq.com/phone_call_reporting',
    opportunityReportingService: 'https://staging.services.leadconnectorhq.com/opportunity_reporting',
    frontEndCNameRedirectURL: 'staging.msgsndr.com',
    cnameRedirectURL: 'flash-funnel-staging.msgsndr.com',
    serverIPAddress: '35.222.170.66',
    cnameWhitelabelURL: 'link.msgsndr.com',
    whitelabelIPAddress: '34.66.216.217',
    companyIdForManagingTemplates: 'eejDKnO8OMdu5q4F7rMB',
    locationIdForTemplateLibrary: 'f8xXtCLtJndXyDchiomd',
    fcmSenderId: '85350210461',
    fcmPublicKey:
      'BGNTatB_WYHmXHCtRGGgF1TPUXoRjrhLrvOKA6sCPjg-v3C1o9TGTZj6cz_CejVb1zykPWRKn-jXTpUfOqTOIR4',
    tipalti:{
        masterKey: 'O+bfhrct8O02s/Qi4kjdtdPRhqgc5jIj5HEqe//r8hF2133w23FzRfcSGY9NPf9J',
        baseURL: 'https://ui2.sandbox.tipalti.com/payeedashboard/'
    },
    firebase: {
      apiKey: 'AIzaSyAbVVAyzRuw0Mx18DYczCehMsjWFCYX1Lo',
      authDomain: 'highlevel-staging.firebaseapp.com',
      databaseURL: 'https://highlevel-staging.firebaseio.com',
      projectId: 'highlevel-staging',
      storageBucket: 'highlevel-staging.appspot.com',
      messagingSenderId: '85350210461',
      appId: '1:85350210461:web:d3728d34bf8bd6b5',
    },
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    stripeKey: 'pk_test_WvH5LGch2F7bqyIJ6gVMu3iE',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    shortenUrlServiceUrl:
      'https://url-shorten-dot-highlevel-staging.appspot.com/',
    membershipUrl:
      'https://staging.services.leadconnectorhq.com/membership',
    membershipAppUrl: 'https://staging.backend.memberships.apisystem.tech',
    cacheInvalidateUrl: 'https://staging.services.leadconnectorhq.com/cache/clear',
    attributionUrl: 'https://staging.services.leadconnectorhq.com/attribution_service',
    emailReportingUrl: 'https://staging.services.leadconnectorhq.com',
    agentReportingUrl: 'https://staging.services.leadconnectorhq.com', //'http://localhost:5020'
    bulkReqURL: 'https://bulk-request-dot-highlevel-staging.uc.r.appspot.com',
    emailHomeAppUrl: 'https://hl-email-home.web.app',
    proposalBuilderAppUrl: 'https://staging-leadgen-apps-proposal-builder.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://hl-email-preview.web.app',
    mediaCenterAppUrl: 'https://hl-media-center.firebaseapp.com',
    templateLibraryAppUrl: 'https://staging-template-library.web.app',
    genericElizaId: 'events-search-enhv',
    workflowAppURL: 'https://hl-workflow.web.app',
    snapshotServiceUrl: 'https://snapshot-dot-highlevel-staging.appspot.com',
    calendarAppURL: process.env.VUE_APP_CALENDAR_APP_URL || 'https://staging-client-app-calendars.web.app',
    crmOpportunitiesAppURL: process.env.VUE_APP_CRM_OPPORTUNITIES_APP_URL || 'https://staging-client-app-crm-opportunities.web.app/',
    crmCustomValuesAppURL: "https://cv-microapp.netlify.app",
    crmTagsAppUrl :  process.env.VUE_APP_CRM_TAGS_APP_URL || 'https://staging-client-app-crm-tags.web.app/',
    calendarRecurringEventsEnabled: ["5DP4iH6HLkQsiKESj6rh", "z15tg6TRo3BPFPhquVuz"],
    crmLocationAppURL: process.env.VUE_APP_CRM_LOCATIONS_APP_URL || 'https://staging-crm-apps-rollup.leadconnectorhq.com',
    newCalendarSettingsEnabled: ["5DP4iH6HLkQsiKESj6rh"],
    workflowServiceURL: 'https://staging.services.leadconnectorhq.com/workflow',
    newOnboardingFrontend: 'https://staging.onboarding.gohighlevel.com',
    hipaaComplianceServiceId: 'tecJjL67Ol5kwLItrBwe',
    gdprSignDocument:
      'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    termsOfServiceThrottle: 3,
    publicApiUrl: 'https://public-api-dot-highlevel-staging.uc.r.appspot.com',
    restApiUrl: 'https://staging.services.leadconnectorhq.com',
    funnelsApiURL: 'https://staging.services.leadconnectorhq.com',
    statsApiURL: 'https://staging.services.leadconnectorhq.com',
    requestLoggerApiURL: 'https://staging.services.leadconnectorhq.com',
    productsApiURL: 'https://staging.services.leadconnectorhq.com',
    paymentsApiURL: 'https://staging.services.leadconnectorhq.com',
    paymentsAppUrl:'https://ghl-payments-staging.web.app',
    cloudFunctionsUrl:
      'https://us-central1-highlevel-staging.cloudfunctions.net',
    reserveServiceBaseUrl: 'https://staging.services.leadconnectorhq.com/reserve',
    deepLinkUrl:'https://deep-link-dot-highlevel-staging.uc.r.appspot.com',
    depreciatedFeatureDate: '2021-09-21',
    googleAuthId: "85350210461-eu3b772ek6gqmlpeim86m62ab9i9u5pc.apps.googleusercontent.com",
    funnelBuilderAppURL: "https://page-builder-staging.leadconnectorhq.com",
    formBuilderAppURL: "https://ghl-form-survey-builder-staging.web.app",
    socialMediaPlannerAppUrl: 'https://staging-social-media-posting.web.app',
    affiliateManagerAppUrl: 'https://staging-affiliate-manager.web.app',
    funnelBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    formBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    surveyBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    calendarBetaPreviewUrl: 'https://beta-labs-dot-funnel-preview-dot-highlevel-staging.appspot.com',
    tosVersion: '06/01/2022',
    privacyPolicyVersion: '06/01/2022',
    affiliatePolicyVersion: '03/02/2021',
    supportPortalUrl: 'https://ghl-support-portal.web.app/',
    wordpress:{
      apiUrl: 'https://staging.services.leadconnectorhq.com/wordpress',
    },
    prospect: {
      frontendUrl: 'https://aadityagohigh2.netlify.app'
    },
    reputation: {
      apiUrl: 'https://staging.services.leadconnectorhq.com/reputation'
    },
    blogsAppUrl: 'https://ghl-blogs-staging.web.app',
    formsApiUrl: 'https://staging.services.leadconnectorhq.com',
    conversationsAppUrl: 'https://staging-client-app-crm-conversations.web.app',
    isvAppUrl: 'https://ghl-isv-app.web.app',
    settingsAppUrl: 'https://staging-client-app-crm-settings.web.app',
    triggerLinksAppUrl: 'https://staging-client-app-crm-links.web.app',
    localizationApiURL: 'https://staging.services.leadconnectorhq.com/localization',
    newFunnelBuilderUrl: 'https://page-builder-staging--beta-c5b2hybo.web.app',
    isAddGuestsEnabled: ['5DP4iH6HLkQsiKESj6rh', 'aM2Z760DXgoa6AIEZx8N'],
    newEmailHomeBetaUrl: 'https://hl-email-home--anz-staging-wapmruc1.web.app',
    newEmailPreviewBetaUrl: 'https://hl-email-preview--anz-staging-qj636k3k.web.app',
    conversationsServiceUrl: 'https://staging.services.leadconnectorhq.com/conversations',
    mobileAppCustomiserAppUrl: 'https://staging-client-app-revex.leadconnectorhq.com/mobile-customiser',
  },
  beta: {
    mode: 'production',
    leadConnectorFrontendBaseUrl: 'https://app.leadconnectorhq.com',
    baseUrl: 'https://beta-dot-highlevel-backend.appspot.com',
    newBaseUrl: 'https://services.leadconnectorhq.com/appengine',
    ghlRevexBackendWhatsAppBaseUrl: 'https://services.leadconnectorhq.com/phone-system/whatsapp',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v18.0',
    formEmbedUrl: 'https://link.gohighlevel.com/js/beta',
    funnelShare:'https://affiliates.gohighlevel.com',
    widgetUrl: 'https://beta-dot-funnel-preview-dot-highlevel-backend.appspot.com',
    pythonBaseUrl: 'https://beta-dot-python-backend-dot-highlevel-backend.appspot.com',
    dialogflowEngagementsBaseUrl:
      'https://services.leadconnectorhq.com/dialogflow-engagement',
    paymentServiceBaseUrl: 'https://services.leadconnectorhq.com/payment_service',
    saasServiceBaseUrl: 'https://services.leadconnectorhq.com/saas_service', // Production(Beta) saas URL
    isvServiceBaseUrl: 'https://services.leadconnectorhq.com/isv_service', // Production(Beta) isv URL
    humanRollOverServiceBaseUrl: 'https://services.leadconnectorhq.com/eliza',
    funnelServiceBaseUrl: 'https://services.leadconnectorhq.com/funnel_backend',
    phoneCallReportingService: 'https://services.leadconnectorhq.com/phone_call_reporting',
    opportunityReportingService: 'https://services.leadconnectorhq.com/opportunity_reporting',
    frontEndCNameRedirectURL: 'app.msgsndr.com',
    cnameRedirectURL: 'flash.funnels.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    serverIPAddress: '34.68.234.4',
    whitelabelIPAddress: '34.70.111.192',
    companyIdForManagingTemplates: 'pfpm9iFi4k5yvjnstXWU',
    locationIdForTemplateLibrary: 'BDB6ZHTCnEejjv30r16r',
    fcmSenderId: '439472444885',
    fcmPublicKey:
      'BAVB9sZxhteplpxkSQXvCF57NEXzFZbC3aO6sFxQGH5vujYLN12R6HxD52REe_xMotrXqAIeroKrQlAAgJH3hMc',
    tipalti:{
        masterKey: '2CbN+Sct9H/cc41OzqfKX64aZL3SrQqijgzwhpTPv/PDyhJ6badnhD0XTodX6QEX',
        baseURL: 'https://ui2.tipalti.com/payeedashboard/'
    },
    firebase: {
      apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
      authDomain: 'highlevel-backend.firebaseapp.com',
      databaseURL: 'https://highlevel-backend.firebaseio.com',
      projectId: 'highlevel-backend',
      storageBucket: 'highlevel-backend.appspot.com',
      messagingSenderId: '439472444885',
      appId: '1:439472444885:android:c48022009a58ffc7',
    },
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    stripeKey: 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    shortenUrlServiceUrl:
      'https://url-shorten-dot-highlevel-backend.appspot.com/',
    membershipUrl:
      'https://services.leadconnectorhq.com/membership',
    membershipAppUrl: 'https://backend.memberships.apisystem.tech',
    cacheInvalidateUrl: 'https://services.leadconnectorhq.com/cache/clear',
    attributionUrl: 'https://services.leadconnectorhq.com/attribution_service',
    emailReportingUrl: 'https://services.leadconnectorhq.com',
    agentReportingUrl: 'https://services.leadconnectorhq.com',
    bulkReqURL: 'https://bulk-request-dot-highlevel-backend.uc.r.appspot.com',
    genericElizaId: 'snehal-new-agent-kqqa',
    emailHomeAppUrl: 'https://email-home-beta.web.app',
    proposalBuilderAppUrl: 'https://staging-leadgen-apps-proposal-builder.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://email-preview-beta.web.app',
    mediaCenterAppUrl: 'https://media-center-prod.firebaseapp.com',
    templateLibraryAppUrl: 'https://beta-template-library.web.app',
    calendarAppURL: 'https://calendar-app.leadconnectorhq.com',
    crmOpportunitiesAppURL:'https://client-app-crm-opportunities.web.app/',
    crmTagsAppUrl :  'https://client-app-crm-tags.web.app/',
    crmCustomValuesAppURL: 'https://client-app-crm-custom-values.web.app',
    calendarRecurringEventsEnabled: ["YuTUZlUtrwBtvmgByZDW"],
    crmLocationAppURL: 'https://client-app-crm-locations.leadconnectorhq.com',
    newCalendarSettingsEnabled: ["YuTUZlUtrwBtvmgByZDW"],
    workflowAppURL: 'https://client-app-automation-workflows.leadconnectorhq.com',
    workflowServiceURL: 'https://services.leadconnectorhq.com/workflow',
    newOnboardingFrontend: 'https://ghl-onboarding.web.app',
    hipaaComplianceServiceId: '1kMapL1iT8LNZhXsv6IC',
    gdprSignDocument:
      'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    snapshotServiceUrl: 'https://snapshot-dot-highlevel-backend.appspot.com',
    termsOfServiceThrottle: 100,
    publicApiUrl: 'https://rest.gohighlevel.com',
    restApiUrl: 'https://services.leadconnectorhq.com',
    paymentsAppUrl: "https://ghl-payments-beta.web.app",
    cloudFunctionsUrl: 'https://us-central1-highlevel-backend.cloudfunctions.net',
    reserveServiceBaseUrl: 'https://services.leadconnectorhq.com/reserve',
    deepLinkUrl:'https://deep-link-dot-highlevel-backend.uc.r.appspot.com',
    depreciatedFeatureDate: '2021-10-21',
    googleAuthId: "662044898224-7rdo6sjo4hf8qief3lpqb24bh9rvut5t.apps.googleusercontent.com",
    funnelBuilderAppURL: "https://beta-page-builder.leadconnectorhq.com/",
    formBuilderAppURL: "https://beta-leadgen-apps-form-survey-builder.leadconnectorhq.com",
    socialMediaPlannerAppUrl: 'https://social-media-posting.leadconnectorhq.com',
    affiliateManagerAppUrl: 'https://client-app-affiliate-manager.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    surveyBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    tosVersion: '06/01/2022',
    privacyPolicyVersion: '06/01/2022',
    affiliatePolicyVersion: '03/02/2021',
    supportPortalUrl: 'https://support.leadconnectorhq.com/',
    wordpress:{
      apiUrl: 'https://services.leadconnectorhq.com/wordpress',
    },
    prospect: {
      frontendUrl: 'https://prod-location-prospect.web.app'
    },
    reputation: {
      apiUrl: 'https://services.leadconnectorhq.com/reputation'
    },
    blogsAppUrl: 'https://ghl-blogs-beta.web.app',
    conversationsAppUrl: 'https://client-app-crm-conversations.web.app',
    isvAppUrl: 'https://ghl-isv-app-prod.web.app',
    settingsAppUrl: 'https://client-app-crm-settings.leadconnectorhq.com',
    triggerLinksAppUrl: 'https://client-app-crm-links.web.app/',
    statsApiURL: 'https://services.leadconnectorhq.com',
    newFunnelBuilderUrl: "https://beta-page-builder.leadconnectorhq.com",
    isAddGuestsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    newEmailHomeBetaUrl: 'https://email-home-beta.web.app',
    newEmailPreviewBetaUrl: 'https://email-preview-beta.web.app',
    conversationsServiceUrl: 'https://services.leadconnectorhq.com/conversations',
    mobileAppCustomiserAppUrl: 'https://client-app-revex.leadconnectorhq.com/mobile-customiser',
    localizationApiURL: 'https://services.leadconnectorhq.com/localization',
  },
  production: {
    mode: 'production',
    leadConnectorFrontendBaseUrl: 'https://app.leadconnectorhq.com',
    baseUrl: 'https://api.leadconnectorhq.com',
    newBaseUrl: 'https://services.leadconnectorhq.com/appengine',
    ghlRevexBackendWhatsAppBaseUrl: 'https://services.leadconnectorhq.com/phone-system/whatsapp',
    whatsappMetaAppId: 390181264778064,
    whatsappMetaAppVersion: 'v18.0',
    formEmbedUrl: 'https://link.msgsndr.com/js',
    widgetUrl: 'https://api.leadconnectorhq.com',
    pythonBaseUrl: 'https://python-backend-dot-highlevel-backend.appspot.com',
    dialogflowEngagementsBaseUrl:
      'https://services.leadconnectorhq.com/dialogflow-engagement',
    funnelShare:'https://affiliates.gohighlevel.com',
    paymentServiceBaseUrl: 'https://services.leadconnectorhq.com/payment_service',
    saasServiceBaseUrl: 'https://services.leadconnectorhq.com/saas_service', // Production saas URL
    isvServiceBaseUrl: 'https://services.leadconnectorhq.com/isv_service', // Production saas URL
    humanRollOverServiceBaseUrl: 'https://services.leadconnectorhq.com/eliza',
    funnelServiceBaseUrl: 'https://services.leadconnectorhq.com/funnel_backend',
    phoneCallReportingService: 'https://services.leadconnectorhq.com/phone_call_reporting',
    opportunityReportingService: 'https://services.leadconnectorhq.com/opportunity_reporting',
    frontEndCNameRedirectURL: 'app.msgsndr.com',
    cnameRedirectURL: 'flash.funnels.msgsndr.com',
    cnameWhitelabelURL: 'link.msgsndr.com',
    serverIPAddress: '34.68.234.4',
    whitelabelIPAddress: '34.70.111.192',
    crmOpportunitiesAppURL:'https://client-app-crm-opportunities.web.app/',
    crmTagsAppUrl : 'https://client-app-crm-tags.web.app/',
    crmCustomValuesAppURL: "https://client-app-crm-custom-values.web.app",
    companyIdForManagingTemplates: 'pfpm9iFi4k5yvjnstXWU',
    locationIdForTemplateLibrary: 'BDB6ZHTCnEejjv30r16r',
    fcmSenderId: '439472444885',
    fcmPublicKey:
      'BAVB9sZxhteplpxkSQXvCF57NEXzFZbC3aO6sFxQGH5vujYLN12R6HxD52REe_xMotrXqAIeroKrQlAAgJH3hMc',
    tipalti:{
        masterKey: '2CbN+Sct9H/cc41OzqfKX64aZL3SrQqijgzwhpTPv/PDyhJ6badnhD0XTodX6QEX',
        baseURL: 'https://ui2.tipalti.com/payeedashboard/'
    },
    firebase: {
      apiKey: 'AIzaSyB_w3vXmsI7WeQtrIOkjR6xTRVN5uOieiE',
      authDomain: 'highlevel-backend.firebaseapp.com',
      databaseURL: 'https://highlevel-backend.firebaseio.com',
      projectId: 'highlevel-backend',
      storageBucket: 'highlevel-backend.appspot.com',
      messagingSenderId: '439472444885',
      appId: '1:439472444885:android:c48022009a58ffc7',
    },
    googleMapsAPIKey: 'AIzaSyAEWVDkZgkfkJFWQKMPyJWgzXG-XongSRQ',
    defaultReviewSMS:
      'Hi there! Thank you for choosing {{{location.name}}}. Would you be willing to take 30 seconds and leave us a quick review? The link below makes it easy: {{{review_link}}}',
    stripeKey: 'pk_live_MtxwO3obi7pfD7UZlGkfR2yj',
    googleAnalyticId: 'UA-115177999-2',
    smtpServiceUrl: 'https://smpt-service-269314.appspot.com/',
    shortenUrlServiceUrl:
      'https://url-shorten-dot-highlevel-backend.appspot.com/',
    membershipUrl: 'https://services.leadconnectorhq.com/membership',
    newMembershipUrl: 'https://services.leadconnectorhq.com/membership',
    membershipAppUrl: 'https://backend.memberships.apisystem.tech',
    cacheInvalidateUrl: 'https://services.leadconnectorhq.com/cache/clear',
    attributionUrl: 'https://services.leadconnectorhq.com/attribution_service',
    emailReportingUrl: 'https://services.leadconnectorhq.com',
    agentReportingUrl: 'https://services.leadconnectorhq.com',
    bulkReqURL: 'https://api.leadconnectorhq.com',
    genericElizaId: 'snehal-new-agent-kqqa',
    emailHomeAppUrl: 'https://email-home-prod.web.app',
    proposalBuilderAppUrl: 'https://leadgen-apps-proposal-builder.leadconnectorhq.com',
    emailPreviewAppUrl: 'https://email-preview-prod.web.app',
    mediaCenterAppUrl: 'https://media-center-prod.firebaseapp.com',
    templateLibraryAppUrl: 'https://prod-template-library.web.app',
    workflowAppURL: 'https://client-app-automation-workflows.leadconnectorhq.com',
    calendarAppURL: 'https://calendar-app.leadconnectorhq.com',
    calendarRecurringEventsEnabled: ["YuTUZlUtrwBtvmgByZDW"],
    crmLocationAppURL: 'https://client-app-crm-locations.leadconnectorhq.com',
    newCalendarSettingsEnabled: ["YuTUZlUtrwBtvmgByZDW"],
    workflowServiceURL: 'https://services.leadconnectorhq.com/workflow',
    newOnboardingFrontend: 'https://onboarding.gohighlevel.com',
    hipaaComplianceServiceId: '1kMapL1iT8LNZhXsv6IC',
    gdprSignDocument:
      'https://eform.pandadoc.com/?eform=5709f455-14d4-49ec-9b71-48c3ef52be50',
    snapshotServiceUrl: 'https://snapshot-dot-highlevel-backend.appspot.com',
    termsOfServiceThrottle: 100,
    publicApiUrl: 'https://rest.gohighlevel.com',
    restApiUrl: 'https://services.leadconnectorhq.com',
    paymentsAppUrl: "https://ghl-payments.web.app",
    cloudFunctionsUrl: 'https://us-central1-highlevel-backend.cloudfunctions.net',
    reserveServiceBaseUrl: 'https://services.leadconnectorhq.com/reserve',
    deepLinkUrl:'https://deep-link-dot-highlevel-backend.uc.r.appspot.com',
    depreciatedFeatureDate: '2021-10-21',
    googleAuthId: "662044898224-7rdo6sjo4hf8qief3lpqb24bh9rvut5t.apps.googleusercontent.com",
    funnelBuilderAppURL: "https://page-builder.leadconnectorhq.com",
    formBuilderAppURL: "https://leadgen-apps-form-survey-builder.leadconnectorhq.com",
    socialMediaPlannerAppUrl: 'https://social-media-posting-prod.web.app',
    affiliateManagerAppUrl: 'https://client-app-affiliate-manager.leadconnectorhq.com',
    funnelBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    formBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    surveyBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    tosVersion: '06/01/2022',
    privacyPolicyVersion: '06/01/2022',
    affiliatePolicyVersion: '03/02/2021',
    calendarBetaPreviewUrl: 'https://beta-widget.leadconnectorhq.com',
    supportPortalUrl: 'https://support.leadconnectorhq.com/',
    wordpress:{
      apiUrl: 'https://services.leadconnectorhq.com/wordpress',
    },
    prospect: {
      frontendUrl: 'https://prod-location-prospect.web.app'
    },
    reputation: {
      apiUrl: 'https://services.leadconnectorhq.com/reputation'
    },
    blogsAppUrl: 'https://ghl-blogs-prod.web.app',
    formsApiUrl: 'https://services.leadconnectorhq.com',
    conversationsAppUrl: 'https://client-app-crm-conversations.web.app',
    isvAppUrl: 'https://ghl-isv-app-prod.web.app',
    settingsAppUrl: 'https://client-app-crm-settings.leadconnectorhq.com',
    triggerLinksAppUrl: 'https://client-app-crm-links.web.app/',
    statsApiURL: 'https://services.leadconnectorhq.com',
    newFunnelBuilderUrl: "https://beta-page-builder.leadconnectorhq.com",
    isAddGuestsEnabled: ['YuTUZlUtrwBtvmgByZDW'],
    newEmailHomeBetaUrl: 'https://email-home-beta.web.app',
    newEmailPreviewBetaUrl: 'https://email-preview-beta.web.app',
    conversationsServiceUrl: 'https://services.leadconnectorhq.com/conversations',
    mobileAppCustomiserAppUrl: 'https://client-app-revex.leadconnectorhq.com/mobile-customiser',
    localizationApiURL: 'https://services.leadconnectorhq.com/localization',
  },
}

const configurations = config[process.env.NODE_ENV]

if(process.env.NODE_ENV === 'development' && !override){
  switch(process.env.VUE_APP_DEV_TEAM){
    case 'payments':
      configurations.membershipUrl = 'https://staging.services.leadconnectorhq.com/membership'
      configurations.productsApiURL = 'http://localhost:5053'
      configurations.paymentsApiURL = 'http://localhost:5055'
      configurations.requestLoggerApiURL = 'http://localhost:5067'
      configurations.funnelsApiURL = 'http://localhost:5054',
      configurations.statsApiURL= 'http://localhost:5105',
      configurations.paymentsAppUrl = "http://localhost:3040",
      configurations.blogsAppUrl = 'http://localhost:5092'
    break
    case 'snapshots':
      configurations.baseUrl = 'http://localhost:5000',
      configurations.newBaseUrl = 'http://localhost:5000'
    break
  }

}

export default configurations
